"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormNestedTableField = void 0;
const form_field_1 = require("./form-field");
const nested_table_field_1 = require("../../../components/nested-table-field/nested-table-field");
exports.FormNestedTableField = form_field_1.formFieldFactory(nested_table_field_1.NestedTableField);
//# sourceMappingURL=form-nested-table-field.js.map